import { render, staticRenderFns } from "./setBirthdayPage.vue?vue&type=template&id=352fa637&scoped=true&"
import script from "./setBirthdayPage.vue?vue&type=script&lang=js&"
export * from "./setBirthdayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352fa637",
  null
  
)

export default component.exports